import { Grid, Typography } from '@mui/material';
import React from 'react';

import { obscureAccountNo } from 'Lib/stringHelpers';

import type { WalletCompactDetailsProps } from '.';

export default function WalletCompactDetails(props: WalletCompactDetailsProps) {
    const {
        classes,
        accountName,
        accountNo
    } = props;

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            wrap='nowrap'
        >
            <Typography variant='body1'>{accountName}</Typography>
            <Typography
                className={classes.accountText}
                variant='body1'
            >{`${obscureAccountNo(accountNo)}`}
            </Typography>
        </Grid>
    );
}